import { useQuery } from 'react-query'

import { request } from '../api/apiCore'

const fetchRoles = () => request({ url: '/admin/roles.json' })
export const useRolesData = () => useQuery('roles', fetchRoles)

const fetchrole = roleId => request({ url: `/admin/roles/${roleId}.json`, method: 'GET' })
export const useRoleData = id => useQuery(['role', id], () => fetchrole(id))
